(function () {
  if (window.notifyMeInitialized) return;
  window.notifyMeInitialized = true;

  const SALESFORCE_URL = 'REPLACE_WITH_SALESFORCE_WEBHOOK_URL';

  /* ── MODAL: דף מוצר — שם, טלפון, checkbox ── */

  let productModal = null;

  function buildProductModal() {
    const el = document.createElement('div');
    el.id = 'notify-me-modal-product';
    el.setAttribute('hidden', '');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'עדכן אותי כשחוזר למלאי');
    el.innerHTML = `
      <div class="notify-me-overlay"></div>
      <div class="notify-me-dialog">
        <button class="notify-me-close" type="button" aria-label="סגור">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <h3 class="notify-me-title">עדכן אותי כשחוזר למלאי</h3>
        <p class="notify-me-subtitle"></p>
        <form class="notify-me-form" novalidate>
          <input type="hidden" class="nm-product-id">
          <input type="hidden" class="nm-variant-id">
          <input type="hidden" class="nm-product-title">
          <input type="hidden" class="nm-variant-title">
          <div class="notify-me-field">
            <label for="nm-name-product">שם מלא</label>
            <input type="text" id="nm-name-product" class="nm-name" required autocomplete="name" placeholder="ישראל ישראלי">
          </div>
          <div class="notify-me-field">
            <label for="nm-phone-product">מספר טלפון</label>
            <input type="tel" id="nm-phone-product" class="nm-phone" required autocomplete="tel" placeholder="050-0000000">
          </div>
          <div class="notify-me-all-variants-wrap">
            <label class="notify-me-checkbox-label">
              <input type="checkbox" class="nm-all-variants">
              שלחו לי עדכון על כל צבע שחוזר למלאי בדגם זה
            </label>
          </div>
          <p class="notify-me-error-msg" hidden></p>
          <p class="notify-me-success-msg" hidden>תודה! נעדכן אותך כשהמוצר יחזור למלאי.</p>
          <button type="submit" class="notify-me-submit button button--primary button--full-width">שלח</button>
        </form>
      </div>
    `;
    document.body.appendChild(el);
    el.querySelector('.notify-me-overlay').addEventListener('click', closeModal);
    el.querySelector('.notify-me-close').addEventListener('click', closeModal);
    el.querySelector('.notify-me-form').addEventListener('submit', handleSubmit);
    return el;
  }

  /* ── MODAL: כרטיסי קולקציה/השוואה — בורר דגם, שם, טלפון ── */

  let cardModal = null;

  function buildCardModal() {
    const el = document.createElement('div');
    el.id = 'notify-me-modal-card';
    el.setAttribute('hidden', '');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'עדכן אותי כשחוזר למלאי');
    el.innerHTML = `
      <div class="notify-me-overlay"></div>
      <div class="notify-me-dialog">
        <button class="notify-me-close" type="button" aria-label="סגור">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <h3 class="notify-me-title">עדכן אותי כשחוזר למלאי</h3>
        <p class="notify-me-subtitle"></p>
        <form class="notify-me-form" novalidate>
          <input type="hidden" class="nm-product-id">
          <input type="hidden" class="nm-variant-id">
          <input type="hidden" class="nm-product-title">
          <input type="hidden" class="nm-variant-title">
          <div class="nm-options-container"></div>
          <div class="notify-me-all-variants-wrap">
            <label class="notify-me-checkbox-label">
              <input type="checkbox" class="nm-all-variants">
              שלחו לי עדכון על כל צבע שחוזר למלאי בדגם זה
            </label>
          </div>
          <div class="notify-me-field">
            <label for="nm-name-card">שם מלא</label>
            <input type="text" id="nm-name-card" class="nm-name" required autocomplete="name" placeholder="ישראל ישראלי">
          </div>
          <div class="notify-me-field">
            <label for="nm-phone-card">מספר טלפון</label>
            <input type="tel" id="nm-phone-card" class="nm-phone" required autocomplete="tel" placeholder="050-0000000">
          </div>
          <p class="notify-me-error-msg" hidden></p>
          <p class="notify-me-success-msg" hidden>תודה! נעדכן אותך כשהמוצר יחזור למלאי.</p>
          <button type="submit" class="notify-me-submit button button--primary button--full-width">שלח</button>
        </form>
      </div>
    `;
    document.body.appendChild(el);
    el.querySelector('.notify-me-overlay').addEventListener('click', closeModal);
    el.querySelector('.notify-me-close').addEventListener('click', closeModal);
    el.querySelector('.notify-me-form').addEventListener('submit', handleSubmit);
    return el;
  }

  function buildOptionSelects(container, parsedVariants, parsedOptions, currentVariantId, onVariantChange) {
    container.innerHTML = '';

    parsedOptions.forEach(function (optionName, i) {
      const key = 'option' + (i + 1);
      const uniqueValues = parsedVariants
        .map(function (v) { return v[key]; })
        .filter(function (v, idx, arr) { return v != null && arr.indexOf(v) === idx; });

      if (uniqueValues.length === 0) return;

      const field  = document.createElement('div');
      field.className = 'notify-me-field';

      const label  = document.createElement('label');
      label.textContent = optionName;

      const select = document.createElement('select');
      select.className = 'notify-me-select nm-option-select';
      select.dataset.optionIndex = i;

      uniqueValues.forEach(function (val) {
        const opt    = document.createElement('option');
        opt.value    = val;
        opt.textContent = val;
        select.appendChild(opt);
      });

      field.appendChild(label);
      field.appendChild(select);
      container.appendChild(field);
    });

    /* Set initial selection based on currentVariantId or first OOS variant */
    const initialVariant =
      parsedVariants.find(function (v) { return String(v.id) === String(currentVariantId); }) ||
      parsedVariants.find(function (v) { return !v.available; }) ||
      parsedVariants[0];

    if (initialVariant) {
      container.querySelectorAll('.nm-option-select').forEach(function (select) {
        const i   = parseInt(select.dataset.optionIndex, 10);
        const val = initialVariant['option' + (i + 1)];
        if (val != null) select.value = val;
      });
    }

    function getSelectedOptions() {
      return Array.from(container.querySelectorAll('.nm-option-select')).map(function (s) {
        return s.value;
      });
    }

    container.querySelectorAll('.nm-option-select').forEach(function (select) {
      select.addEventListener('change', function () {
        onVariantChange(getSelectedOptions());
      });
    });

    onVariantChange(getSelectedOptions());
  }

  function closeModal() {
    if (productModal) productModal.setAttribute('hidden', '');
    if (cardModal)    cardModal.setAttribute('hidden', '');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* ── OPEN ── */

  function openProductModal({ productId, variantId, productTitle, variantTitle }) {
    if (!productModal) productModal = buildProductModal();
    const m    = productModal;
    const form = m.querySelector('.notify-me-form');

    form.reset();
    m.querySelector('.nm-product-id').value    = productId    || '';
    m.querySelector('.nm-variant-id').value    = variantId    || '';
    m.querySelector('.nm-product-title').value = productTitle || '';
    m.querySelector('.nm-variant-title').value = variantTitle || '';
    m.querySelector('.nm-all-variants').checked = false;

    let subtitle = productTitle || '';
    if (variantTitle && variantTitle !== 'Default Title' && variantTitle !== 'כותרת ברירת מחדל') {
      subtitle += ' — ' + variantTitle;
    }
    m.querySelector('.notify-me-subtitle').textContent = subtitle;

    m.querySelector('.notify-me-error-msg').setAttribute('hidden', '');
    m.querySelector('.notify-me-success-msg').setAttribute('hidden', '');
    const submitBtn = m.querySelector('.notify-me-submit');
    submitBtn.removeAttribute('hidden');
    submitBtn.disabled = false;

    m.removeAttribute('hidden');
    setTimeout(() => m.querySelector('.nm-name').focus({ preventScroll: true }), 50);
  }

  function openCardModal({ productId, variantId, productTitle, variantTitle, variants, productOptions }) {
    if (!cardModal) cardModal = buildCardModal();
    const m    = cardModal;
    const form = m.querySelector('.notify-me-form');

    form.reset();
    m.querySelector('.nm-product-id').value    = productId    || '';
    m.querySelector('.nm-product-title').value = productTitle || '';
    m.querySelector('.nm-all-variants').checked = false;

    const variantIdInput    = m.querySelector('.nm-variant-id');
    const variantTitleInput = m.querySelector('.nm-variant-title');

    const parsedVariants = variants
      ? (typeof variants === 'string' ? JSON.parse(variants) : variants)
      : null;
    const parsedOptions = productOptions
      ? (typeof productOptions === 'string' ? JSON.parse(productOptions) : productOptions)
      : null;

    if (parsedVariants && parsedVariants.length > 0 && parsedOptions) {
      buildOptionSelects(
        m.querySelector('.nm-options-container'),
        parsedVariants,
        parsedOptions,
        variantId,
        function (selectedOptions) {
          const matched = parsedVariants.find(function (v) {
            return selectedOptions.every(function (val, i) {
              return v['option' + (i + 1)] === val;
            });
          });
          if (matched) {
            variantIdInput.value    = matched.id;
            variantTitleInput.value = selectedOptions.join(' / ');
          }
        }
      );
    } else {
      m.querySelector('.nm-options-container').innerHTML = '';
      variantIdInput.value    = variantId    || '';
      variantTitleInput.value = variantTitle || '';
    }

    m.querySelector('.notify-me-subtitle').textContent = productTitle || '';
    m.querySelector('.notify-me-error-msg').setAttribute('hidden', '');
    m.querySelector('.notify-me-success-msg').setAttribute('hidden', '');
    const submitBtn = m.querySelector('.notify-me-submit');
    submitBtn.removeAttribute('hidden');
    submitBtn.disabled = false;

    m.removeAttribute('hidden');
    setTimeout(() => m.querySelector('.nm-name').focus({ preventScroll: true }), 50);
  }

  /* ── FORM SUBMIT ── */

  async function handleSubmit(e) {
    e.preventDefault();
    const form      = e.target;
    const errorEl   = form.querySelector('.notify-me-error-msg');
    const successEl = form.querySelector('.notify-me-success-msg');
    const submitBtn = form.querySelector('.notify-me-submit');

    const name       = form.querySelector('.nm-name').value.trim();
    const phoneRaw   = form.querySelector('.nm-phone').value.trim();
    const phoneDigits = phoneRaw.replace(/\D/g, '');

    if (!name) {
      errorEl.textContent = 'נא למלא שם.';
      errorEl.removeAttribute('hidden');
      return;
    }
    if (!phoneRaw) {
      errorEl.textContent = 'נא למלא מספר טלפון.';
      errorEl.removeAttribute('hidden');
      return;
    }
    if (phoneDigits.length !== 10) {
      errorEl.textContent = 'מספר טלפון חייב להכיל בדיוק 10 ספרות.';
      errorEl.removeAttribute('hidden');
      return;
    }

    const phone = phoneDigits;

    errorEl.setAttribute('hidden', '');
    submitBtn.disabled = true;

    const allVariantsEl = form.querySelector('.nm-all-variants');
    const payload = {
      name,
      phone,
      product_id:          form.querySelector('.nm-product-id').value,
      variant_id:          form.querySelector('.nm-variant-id').value,
      product_title:       form.querySelector('.nm-product-title').value,
      variant_title:       form.querySelector('.nm-variant-title').value,
      notify_all_variants: allVariantsEl ? allVariantsEl.checked : false,
      shop:                (window.Shopify && window.Shopify.shop) || window.location.hostname,
      timestamp:           new Date().toISOString(),
    };

    if (!SALESFORCE_URL || SALESFORCE_URL.startsWith('REPLACE_')) {
      successEl.removeAttribute('hidden');
      submitBtn.setAttribute('hidden', '');
      setTimeout(closeModal, 2000);
      return;
    }

    try {
      const res = await fetch(SALESFORCE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      successEl.removeAttribute('hidden');
      submitBtn.setAttribute('hidden', '');
      setTimeout(closeModal, 2000);
    } catch (_) {
      errorEl.textContent = 'אירעה שגיאה. נסה שנית.';
      errorEl.removeAttribute('hidden');
      submitBtn.disabled = false;
    }
  }

  /* ── BUTTON CLICK — מחליט איזה פופאפ לפתוח ── */

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.notify-me-btn');
    if (!btn) return;

    if (btn.dataset.noVariants) {
      openProductModal({
        productId:    btn.dataset.productId,
        variantId:    btn.dataset.variantId,
        productTitle: btn.dataset.productTitle,
        variantTitle: btn.dataset.variantTitle,
      });
    } else {
      openCardModal({
        productId:      btn.dataset.productId,
        variantId:      btn.dataset.variantId,
        productTitle:   btn.dataset.productTitle,
        variantTitle:   btn.dataset.variantTitle,
        variants:       btn.dataset.variants       || null,
        productOptions: btn.dataset.productOptions || null,
      });
    }
  });

  /* ── PRODUCT PAGE: toggle ATC ↔ notify button ── */

  function applyToggle(btn, isOutOfStock, variant) {
    const sectionId = btn.dataset.sectionId;
    const atcBtn    = document.querySelector('#ProductSubmitButton-' + sectionId);

    if (isOutOfStock) {
      if (atcBtn) atcBtn.style.display = 'none';
      btn.style.display = '';
      if (variant) {
        btn.dataset.variantId    = variant.id;
        btn.dataset.variantTitle = variant.title || '';
      }
    } else {
      if (atcBtn) atcBtn.style.removeProperty('display');
      btn.style.display = 'none';
    }
  }

  function initNotifyBtn(btn) {
    const sectionId = btn.dataset.sectionId;

    const productEl =
      btn.closest('[data-variant-status]') ||
      document.querySelector('.product[data-variant-status]');

    if (productEl) {
      applyToggle(btn, productEl.dataset.variantStatus === 'out-of-stock', null);
      return;
    }

    /* Quick Add fallback: data-variant-status not yet set — read ATC button disabled state */
    const atcBtn = document.querySelector('#ProductSubmitButton-' + sectionId);
    if (atcBtn) applyToggle(btn, atcBtn.hasAttribute('disabled'), null);
  }

  function checkInitialState() {
    document.querySelectorAll('.notify-me-btn[data-section-id]').forEach(initNotifyBtn);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        node.querySelectorAll('.notify-me-btn[data-section-id]').forEach(initNotifyBtn);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  function subscribeToVariantChange() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const data = event && event.data;
        if (!data) return;
        const isOutOfStock = data.variant ? !data.variant.available : true;

        /* Match both regular and quickadd- prefixed section IDs.
           product-info.js publishes with the originalSection ID (without quickadd- prefix),
           but in Quick Add context the button has data-section-id="quickadd-{sectionId}". */
        [data.sectionId, 'quickadd-' + data.sectionId].forEach(function (id) {
          document.querySelectorAll('.notify-me-btn[data-section-id="' + id + '"]')
            .forEach(function (btn) { applyToggle(btn, isOutOfStock, data.variant); });
        });
      });
      return;
    }

    const productEl = document.querySelector('.product[data-variant-status]');
    if (!productEl) return;

    new MutationObserver(function () {
      const isOut = productEl.dataset.variantStatus === 'out-of-stock';
      document.querySelectorAll('.notify-me-btn[data-section-id]').forEach(function (btn) {
        applyToggle(btn, isOut, null);
      });
    }).observe(productEl, { attributes: true, attributeFilter: ['data-variant-status'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      checkInitialState();
      subscribeToVariantChange();
    });
  } else {
    checkInitialState();
    subscribeToVariantChange();
  }

  /* ── QUICK ADD: re-check after modal opens (data-variant-status is set async) ── */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.quickViewOpen) {
    subscribe(PUB_SUB_EVENTS.quickViewOpen, function () {
      setTimeout(checkInitialState, 150);
    });
  }

  /* ── Edge case: notify-me.js loaded for the first time inside an already-open Quick Add ── */
  setTimeout(function () {
    if (document.querySelector('quick-add-modal:not([hidden])')) checkInitialState();
  }, 150);

  /* ── EMAIL SIGNUP FORM ── */

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-email-signup-form]');
    if (!form) return;
    e.preventDefault();
    handleEmailSignup(form);
  });

  async function handleEmailSignup(form) {
    const sectionId = form.dataset.sectionId;
    const errorEl   = document.getElementById('SignupError--' + sectionId);
    const successEl = document.getElementById('SignupSuccess--' + sectionId);
    const submitBtn = form.querySelector('[type="submit"]');

    function showError(msg) {
      if (errorEl) { errorEl.textContent = msg; errorEl.removeAttribute('hidden'); }
    }

    const firstName   = form.querySelector('[name="first_name"]').value.trim();
    const lastName    = form.querySelector('[name="last_name"]').value.trim();
    const email       = form.querySelector('[name="email"]').value.trim();
    const phoneRaw    = form.querySelector('[name="phone"]').value.trim();
    const phoneDigits = phoneRaw.replace(/\D/g, '');

    if (!firstName) { showError('נא למלא שם פרטי.'); return; }
    if (!lastName)  { showError('נא למלא שם משפחה.'); return; }
    if (!email || !email.includes('@')) { showError('נא למלא כתובת אימייל תקינה.'); return; }
    if (!phoneRaw)  { showError('נא למלא מספר טלפון.'); return; }
    if (phoneDigits.length !== 10) { showError('מספר טלפון חייב להכיל בדיוק 10 ספרות.'); return; }

    if (errorEl) errorEl.setAttribute('hidden', '');
    submitBtn.disabled = true;

    const payload = {
      first_name: firstName,
      last_name:  lastName,
      email:      email,
      phone:      phoneDigits,
      source:     'email_signup',
      shop:       (window.Shopify && window.Shopify.shop) || window.location.hostname,
      timestamp:  new Date().toISOString(),
    };

    if (!SALESFORCE_URL || SALESFORCE_URL.startsWith('REPLACE_')) {
      if (successEl) successEl.removeAttribute('hidden');
      submitBtn.setAttribute('hidden', '');
      return;
    }

    try {
      const res = await fetch(SALESFORCE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      if (successEl) successEl.removeAttribute('hidden');
      submitBtn.setAttribute('hidden', '');
    } catch (_) {
      showError('אירעה שגיאה. נסה שנית.');
      submitBtn.disabled = false;
    }
  }

})();
